import { useDataLogsStore } from 'store/modules';

let lastSample = Date.now();
let lastDetect = Date.now();

class DetectWakeMode {
    constructor() {
        this.worker = new Worker('/worker.js');
        this.SAMPLE_RATE = 60000 * 5;
        this.isSleepMode = false;
    }

    init = () => {
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                this.checkSleepMode('visibilitychange');

                if (this.isSleepMode) {
                    this.triggerWakeMode();
                }
            }
        });

        this.worker.onmessage = (e) => {
            if (e.data.action === 'detect') {
                this.isSleepMode = Date.now() - lastDetect >= this.SAMPLE_RATE;

                if (this.isSleepMode) {
                    this.triggerWakeMode();
                }

                lastDetect = Date.now();
            }
        };
    };

    checkSleepMode = (eventName) => {
        this.isSleepMode = Date.now() - lastSample >= this.SAMPLE_RATE;

        if (eventName === 'pusher:pong') {
            useDataLogsStore().setLogItem({
                logLevel: 'info',
                message: 'EventCheckSleepMode',
                details: {
                    isSleepMode: this.isSleepMode,
                    eventName: eventName,
                },
            });
        }

        lastSample = Date.now();
    };

    triggerWakeMode = () => {
        window.postMessage('wakeMode', window.location.origin);
    };

    actionWakeMode = (callBack) => {
        const action = (e) => {
            if (e.data === 'wakeMode') {
                callBack(e);
            }
        };

        window.addEventListener('message', action);

        return () => {
            window.removeEventListener('message', action);
        };
    };
}

export const detectWakeMode = new DetectWakeMode();

export const actionWakeMode = detectWakeMode.actionWakeMode;
export const checkSleepMode = detectWakeMode.checkSleepMode;
